<script setup lang="ts">
import { Contact } from '@/modules/content-blocks/interfaces/contacts-block.interface';

const props = defineProps({
   data: {
      type: Object,
      default: () => ({}),
   },
});

const contacts = computed(() => props.data.contacts as Contact[]);
</script>

<template>
   <section class="contacts-content" v-if="contacts?.length">
      <div class="contacts-content__grid">
         <div v-for="contact in contacts" :key="contact.id" class="contacts-content__card">
            <div class="contacts-content__avatar">
               <img v-if="contact.image?.url" :src="contact.image.url" />
            </div>
            <div class="contacts-content__name" v-if="contact.name">{{ contact.name }}</div>
            <div>
               <div v-if="contact.phone">
                  <a :href="'tel:' + contact.phone">{{ contact.phone }}</a>
               </div>
               <div v-if="contact.email">
                  <a :href="'mailto:' + contact.email">{{ contact.email }}</a>
               </div>
            </div>
         </div>
      </div>
   </section>
   <section v-else class="contacts-content">
      {{ $tb('live-editor.content-blocks.contacts.no-contacts-configured') }}
   </section>
</template>

<style scoped lang="scss">
.contacts-content {
   &__grid {
      display: flex;
      flex-wrap: wrap;
      gap: calc(var(--nxt-gutter-xlarge) * 2);
      justify-content: center;
   }

   &__card {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: var(--nxt-gutter);
   }

   &__avatar {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      overflow: hidden;
      background: var(--nxt-light-grey);
      display: flex;
      align-items: center;
      justify-content: center;

      img {
         width: 100%;
         height: 100%;
         object-fit: cover;
         display: block;
      }
   }

   &__name {
      font-size: var(--nxt-font-xlarge);
      font-weight: var(--nxt-font-bold);
   }
}
</style>
